'use client';
import React from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';

import styles from '../[letter]/styles.module.css';

import { ExtendedLink } from '@/components/ExtendedLink';
import { useNavConfig } from '@/modules/meganav/useNavConfig';

export function PopularBrandsList() {
  const { config: navConfig } = useNavConfig();

  const popularBrands =
    navConfig.find((item) => item.label === 'Brands')?.contentCollection
      .items[0]?.itemsCollection?.items || [];

  return (
    <ul className={styles.brandList}>
      {popularBrands.map(
        (brand) =>
          brand && (
            <li className={styles.brandListItem} key={brand.label}>
              <ExtendedLink
                className={styles.brandListLink}
                href={brand.slug || ''}
              >
                <Body variant="sm-regular">{brand.label}</Body>
              </ExtendedLink>
            </li>
          )
      )}
    </ul>
  );
}
